import HashtagPost from "./hashtag-post";

export default HashtagPost;